module.exports = __webpack_public_path__ + "static/media/spin-win-nfc.24b29fad.png";